export const SET_DOCTOR = 'SET_DOCTOR';
export const SET_DOCTORS = 'SET_DOCTORS';
export const SET_DOCTORS_QUERY_PARAMS = 'SET_DOCTORS_QUERY_PARAMS';
export const SET_DOCTORS_SET_IS_FETCHING = 'SET_DOCTORS_SET_IS_FETCHING';
